export const GET_COIN_PLAN="GET_COIN_PLAN"
export const ADD_COIN_PLAN="ADD_COIN_PLAN"
export const UPDATE_COIN_PLAN="UPDATE_COIN_PLAN"
export const ACTIVE_COIN_PLAN="ACTIVE_COIN_PLAN"
export const POPULAR_COIN_PLAN="POPULAR_COIN_PLAN"
export const GET_COIN_PLAN_STATS_DATA = "GET_COIN_PLAN_STATS_DATA"
export const GET_PLAN_STATS_DATA = "GET_PLAN_STATS_DATA"



